module.exports = __webpack_public_path__ + "img/3.df8246a1.jpg";